import gql from 'graphql-tag'

export const processCavAndTickets = gql`
  mutation processCavAndTickets($idNegotiation: Int!) {
    response:start_processing_cav_and_tickets(id_negotiation: $idNegotiation)
  }
`
